module.exports = __webpack_public_path__ + "img/05.e1ab5932.jpg";